import React, { useState, useEffect } from 'react';
import PLAYER from '../playerData';
import { BOTS } from '../data';
import { getTotalLevels } from '../content/levels';
import { ASSETS } from '../assetManifest';

function Rank({ app }) {
  const [leaderboard, setLeaderboard] = useState([]);
  const [playerRank, setPlayerRank] = useState(0);
  
  useEffect(() => {
    // Calculate player's level (highest completed level + 1, or max level if all completed)
    const totalLevels = getTotalLevels();
    const playerLevel = Math.min(
      PLAYER.completedLevels.length > 0 
        ? Math.max(...PLAYER.completedLevels) + 1 
        : 1,
      totalLevels
    );
    
    // Create combined leaderboard with player and bots
    const playerEntry = {
      id: 'player',
      name: PLAYER.name,
      emoji: PLAYER.avatarEmoji,
      level: playerLevel,
      isPlayer: true
    };
    
    const combinedLeaderboard = [...BOTS, playerEntry]
      .sort((a, b) => b.level - a.level || a.id - b.id);
    
    // Find player's rank
    const rank = combinedLeaderboard.findIndex(entry => entry.isPlayer) + 1;
    
    setLeaderboard(combinedLeaderboard);
    setPlayerRank(rank);
  }, []);
  
  return (
    <div className="Levels w-full h-full relative overflow-hidden">
      <div className="LevelDetails w-full h-[844px] left-0 top-[-77px] absolute">
        <img 
          className="LevelsBg1 w-full h-[844px] left-0 top-0 absolute" 
          src={ASSETS.backgrounds.levelsBackground.path} 
          alt="Background"
        />
        
        <div className="LockedLevelBg w-[353px] h-[514px] left-[19px] top-[239px] absolute bg-[#1f1f1f]/70 rounded shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-black" />
        
        <div className="UnlockedLevelDetails w-[353px] h-[77px] left-[18px] top-[153px] absolute">
          <div className="UnlockedLevelBackground w-[353px] h-[77px] left-0 top-0 absolute bg-[#141034]/70 rounded shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-[#22c225]" />
          <div className="LevelName w-[93px] h-[23px] left-[51px] top-[28px] absolute text-white text-base font-bold font-['Asap'] uppercase">your rank</div>
          <div className="LevelName w-[99px] h-[66px] left-[188px] top-[6px] absolute text-center text-[#46fb7c] text-[32px] font-extrabold font-['Asap'] uppercase">{playerRank}</div>
        </div>
        
        <div className="LevelsTitleText w-[193px] h-[46px] left-[96px] top-[107px] absolute text-center text-[#efbb57] text-xl font-extrabold font-['Asap'] uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">leaderboard</div>
      </div>
      
      <div className="w-11 h-[35px] left-[35px] top-[173px] absolute text-center text-white text-sm font-extrabold font-['Asap'] uppercase">#</div>
      <div className="Name w-[79px] h-[35px] left-[98px] top-[173px] absolute text-white text-sm font-extrabold font-['Asap'] uppercase">Name</div>
      <div className="Level w-[79px] h-[35px] left-[286px] top-[173px] absolute text-center text-white text-sm font-extrabold font-['Asap'] uppercase">Level</div>
      <div className="Line1 w-[323px] h-[0px] left-[35px] top-[209px] absolute border border-white"></div>
      
      <div className="flex-1 overflow-y-auto absolute top-[216px] left-[34px] w-[334px]">
        {leaderboard.map((entry, index) => (
          <div 
            key={entry.id}
            className="Group w-[334px] h-[43px] relative mb-0 flex items-center"
          >
            <div className="w-11 h-[35px] left-[1px] top-0 absolute flex items-center justify-center text-[#ffce55] text-xs font-extrabold font-['Asap'] uppercase">
              {index + 1}
            </div>
            <div className="w-[98px] h-[35px] left-[82px] top-0 absolute flex items-center text-[#ffce55] text-xs font-extrabold font-['Asap'] uppercase truncate">
              {entry.name}
            </div>
            <div className="w-[79px] h-[35px] left-[255px] top-0 absolute flex items-center justify-center text-[#ffce55] text-xs font-extrabold font-['Asap'] uppercase">
              LEVEL {entry.level}
            </div>
            <div className="Line2 w-[323px] h-[0px] left-0 top-[43px] absolute border border-[#595858]"></div>
            <div className="w-[30px] h-[30px] left-[45px] top-0 absolute flex items-center justify-center text-xl h-full">
              {entry.emoji}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Rank;
